/**
 * The human readable strings for the postings filter options
 *
 * @type {Object}
 */
import { EMBER_ROUTE_NAMES } from "../routes";

export const POSTINGS_DASHBOARD_ASSIGNMENT_SUMMARY_INCLUDES = [
  'company-team',
];

/**
 * The number of postings we'll retrieve per page.
 *
 * @type {number}
 */
export const POSTINGS_PER_PAGE = 10;

/**
 * Number of characters we'll allow before sending a request.
 *
 * @type {number}
 */
export const POSTINGS_SEARCH_CHARACTERS_BEFORE_REQUEST = 1;

/**
 * The human readable 'assignment' sort options
 *
 * @type {Object}
 */
export const POSTINGS_SORT_OPTIONS = {
  LAST_ACTIVITY: 'Last activity',
  DATE_CREATED: 'Date created',
  DATE_POSTED: 'Date posted',
  DATE_SUBMITTED: 'Date submitted',
  DEADLINE: 'Deadline',
  NEEDS_ACTION: 'Needs Action',
  UNREAD_MESSAGES: 'Unread Messages'
};

/**
 * API Enum strings that we'll be passing down to the api for the sort
 *
 * @type {Object}
 */
export const POSTINGS_SORT_API_ENUMS = {
  LAST_ACTIVITY: 'last-activity',
  DATE_CREATED: 'posted',
  DATE_POSTED: 'posted',
  DATE_SUBMITTED: 'posted',
  DEADLINE: 'deadline',
  NEEDS_ACTION: 'needs-action',
  SELLER_RELEVANCE: 'seller-relevance',
  UNREAD_MESSAGES: 'unread-messages',
};

/**
 * The navigation titles for the Postings View e.g. postings/live and etc.
 *
 * @type {Object}
 */
export const POSTINGS_NAV_TITLES = {
  LIVE: 'Live',
  DRAFT: 'Draft',
  CLOSED: 'Closed',
  IN_REVIEW: 'In Review'
};

/**
 * Map of PostingNavTitle => Ember Route Name for that nav title
 *
 * @type {Object}
 */
export const POSTINGS_NAV_TITLES_TO_ROUTES_MAP = {
  [POSTINGS_NAV_TITLES.LIVE] : EMBER_ROUTE_NAMES.POSTINGS__LIVE,
  [POSTINGS_NAV_TITLES.DRAFT] : EMBER_ROUTE_NAMES.POSTINGS__DRAFT,
  [POSTINGS_NAV_TITLES.CLOSED] : EMBER_ROUTE_NAMES.POSTINGS__CLOSED,
  [POSTINGS_NAV_TITLES.IN_REVIEW] : EMBER_ROUTE_NAMES.POSTINGS__IN_REVIEW
};

/**
 * API Enum strings that we'll be passing down to the api for the 'network' filter
 *
 * @type {Object}
 */
export const POSTINGS_EXPLORE_FILTER_API_ENUMS = {
  MIN_DAY_RATE: 'minimum_day_rate',
  PLACE_ID: 'place_id',
  IS_REMOTE: 'remote',
  NO_FEES: 'has_no_fees',
  COVERS_EXPENSES: 'covers_expenses',
  SERVICE_MATCH: 'user_offered_services',
};

/**
 * The human readable strings for the postings 'network' filter options
 *
 * @type {Object}
 */
export const POSTINGS_NETWORK_FILTER_OPTIONS = {
  CREATED_BY_ANYONE: 'Created by anyone',
  CREATED_BY_YOU: 'Created by you',
  CREATED_BY_OTHERS: 'Created by others',

  POSTED_BY_ANYONE: 'Posted by anyone',
  POSTED_BY_YOU: 'Posted by you',
  POSTED_BY_OTHERS: 'Posted by others'
};

/**
 * The human readable strings for the postings 'company team' filter options
 *
 * @type {Object}
 */
 export const POSTINGS_COMPANY_TEAM_FILTER_OPTIONS = {
  ALL_TEAMS: 'All Teams',
};

/**
 * API Enum strings that we'll be passing down to the api for the 'network' filter
 *
 * @type {Object}
 */
export const POSTINGS_NETWORK_FILTER_API_ENUMS = {
  POSTED_BY_ANYONE: 'all',
  POSTED_BY_YOU: 'me',
  POSTED_BY_OTHERS: 'others'
};

/**
 * Seller posting subtab names for Applications tab
 *
 * @type {Object}
 */
export const SELLER_POSTINGS_APPLICATIONS_TAB_NAMES = {
  SUBMITTED: 'Submitted',
  HIRED: 'Hired',
};

/**
 * Seller posting subtab names for Find Work tab
 *
 * @type {Object}
 */
export const SELLER_POSTINGS_FIND_WORK_TAB_NAMES = {
  RECOMMENDED: 'Recommended',
  OTHER: 'Explore',
  SAVED: 'Saved',
};
